import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import {EventTracker} from './GoogleAnalytics';
import {useLocation} from 'react-router-dom';

export default function CTAJumbo({cta, ctaLink, buttonText}) {
    const currentLocation = useLocation().pathname;
    const category = 'apply';
    const action = `clicked apply CTA at bottom of ${currentLocation}`;
    return (
        <Container fluid className="bg-secondary">
            <Container>
                <Row>
                    <Col xs={12} className="text-center py-2 py-md-5">
                        <p className="h3 bold text-primary">
                            {cta}
                        </p>
                        <a href={ctaLink} className="btn btn-primary mt-1 mt-md-3" onClick={() => EventTracker(category, action)}>{buttonText}</a>
                    </Col>
                </Row>
            </Container>
    </Container>
    )
}